import { User, UserId } from "@sp-crm/core";
import { Action } from "redux";
import * as browser from "../../util/browser";
import { Actions } from "../actions";

export interface SingleUserState {
    loggedIn: boolean;
    userId: UserId;
    user: User | null;
}

function buildState(): SingleUserState {
    const userId = browser.getUserId();
    const loggedIn = userId && userId !== "" ? true : false;
    const state: SingleUserState = {
        loggedIn,
        userId,
        user: null,
    };
    return state;
}

export function singleUserReducer(
    state: SingleUserState,
    action: Action,
): SingleUserState {
    if (!state || action.type === Actions[Actions.LOGOUT]) {
        state = buildState();
    }

    if (
        action.type === Actions[Actions.LOGIN_START] ||
        action.type === Actions[Actions.LOGIN_FINISH] ||
        action.type === Actions[Actions.LOGOUT]
    ) {
        state = buildState();
    }
    if (action.type === Actions[Actions.LOAD_PERMISSIONS_FINISH]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        const user = (action as any).data.user;

        if (user) {
            state = {
                loggedIn: true,
                userId: user.id,
                user,
            };
        }
    }

    return state;
}
